module.exports = __webpack_public_path__ + "static/media/low.85b78f6d.png";